"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDVMember = exports.isEmailAllowedToVerify = exports.getDVTeamMembersEmails = exports.getDefaultProfiles = exports.getDefaultProfilesForMobile = exports.getDefaultProfilesForWeb = exports.DEFAULT_ROLES = void 0;
const adminActions_1 = require("./adminActions");
const editorActions_1 = require("./editorActions");
const freeTrialActions_1 = require("./freeTrialActions");
const viewerActions_1 = require("./viewerActions");
var DEFAULT_ROLES;
(function (DEFAULT_ROLES) {
    DEFAULT_ROLES["VIEWER"] = "viewer";
    DEFAULT_ROLES["EDITOR"] = "editor";
    DEFAULT_ROLES["ADMIN"] = "admin";
    DEFAULT_ROLES["FREE_TRIAL"] = "free_trial";
})(DEFAULT_ROLES || (exports.DEFAULT_ROLES = DEFAULT_ROLES = {}));
const getDefaultProfilesForWeb = (withFreeTrial) => {
    return (0, exports.getDefaultProfiles)(withFreeTrial);
};
exports.getDefaultProfilesForWeb = getDefaultProfilesForWeb;
const getDefaultProfilesForMobile = (withFreeTrial) => {
    return (0, exports.getDefaultProfiles)(withFreeTrial);
};
exports.getDefaultProfilesForMobile = getDefaultProfilesForMobile;
const getDefaultProfiles = (withFreeTrial) => {
    const profiles = [
        {
            name: DEFAULT_ROLES.VIEWER,
            access_all_resources: false,
            actions: viewerActions_1.viewerActions,
        },
        {
            name: DEFAULT_ROLES.EDITOR,
            access_all_resources: true,
            actions: editorActions_1.editorActions,
        },
        {
            name: DEFAULT_ROLES.ADMIN,
            access_all_resources: true,
            actions: adminActions_1.adminActions,
        },
    ];
    if (withFreeTrial) {
        profiles.push({
            name: DEFAULT_ROLES.FREE_TRIAL,
            access_all_resources: true,
            actions: freeTrialActions_1.freeTrialActions,
        });
    }
    return profiles;
};
exports.getDefaultProfiles = getDefaultProfiles;
const getDVTeamMembersEmails = () => {
    return [
        "charles.sporrer+v3@optimetriks.com",
        "jmazars+v3@optimetriks.com",
        "ibrahima.sow+v3@optimetriks.com",
        "sa@optimetriks.com", // is super admin account,
        "alphonce.ouma@optimetriks.com",
        "morris.kariuki@optimetriks.com",
        "pmuchangi@optimetriks.com",
        "emma.boucheron@optimetriks.com",
        "emma.boucheron+v3admin@optimetriks.com",
    ];
};
exports.getDVTeamMembersEmails = getDVTeamMembersEmails;
/**
 *
 * @deprecated
 * should be removed in the future
 * Use isDVMember instead
 */
const isEmailAllowedToVerify = (email) => {
    if (!email)
        return false;
    return (0, exports.getDVTeamMembersEmails)().includes(email);
};
exports.isEmailAllowedToVerify = isEmailAllowedToVerify;
const isDVMember = (email) => {
    if (!email)
        return false;
    return (0, exports.getDVTeamMembersEmails)().includes(email);
};
exports.isDVMember = isDVMember;
